export const UPDATE_HANDLER_ARGUMENTS = {
  COLOR_TYPE: {
    ERROR_MESSAGE: 'couldNotUpdateBusinessPlanColor',
    METADATA_KEY: 'documentColorType',
  },
  DOCUMENT_STYLE: {
    ERROR_MESSAGE: 'couldNotUpdateBusinessPlanStyle',
    METADATA_KEY: 'documentStyleType',
  },
  ONE_PAGE_STYLE: {
    ERROR_MESSAGE: 'couldNotUpdateBusinessPlanStyle',
    METADATA_KEY: 'onePageTemplateStyle',
  }
} as const;
